export default "https://cdn-static.gokick.com/assets/a667d1dc3297954618d7ed7be4de1ad72d2b7ee9/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";